import {
  isShowAnalyticsEventLoaded,
  calculateCartData,
  caesarDecrypt,
} from "@/utils/helper"
import { getAnalyticsUrl, sanitizeTextForAnalytics } from "@/utils/helper"

const addShippingAnalytics = (status, message, i18n) => {
  if (window.adobeDataLayer) {
    const eventInfo = getShippingEventInfo("next", true)
    if (status) {
      eventInfo.eventStatus = status
    }
    if (message) {
      if (
        message === "failed to set shipping address." ||
        message === "failed to get shipping options."
      ) {
        message = i18n.shippingProcessError?.toLowerCase()
      }
      eventInfo.eventMsg = message
    }
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
    })
  }
}

const getShippingEventInfo = (type, needJSON = false) => {
  const eventInfo = {
    eventAction: "checkout:shipping:" + type,
    eventName: "checkout:shipping:" + type,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue to delivery",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const calculateCartAnalytics = ({ cart }) => {
  const page = window.pageObj || {}
  page.cart = cart
  page.user = getUserAnalyticsObject()
  // push this data to data layer in show event
  if (
    page.user &&
    (!page.user.gId || page.user.gId === "n/a") &&
    (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
  ) {
    window.pageObj = page
    window.isShowAnalyticsEvent = true
  } else if (!isShowAnalyticsEventLoaded()) {
    window.adobeDataLayer.push({
      event: "cmp:show",
      page,
    })
    delete window.pageObj
  }
}

const getUserAnalyticsObject = (isFromRegisterUser = false) => {
  const hashedEmail = localStorage.getItem("hashedEmail")
  const customerProspect = localStorage.getItem("customerProspect")
  let isCustomerOrProspect = "n/a"
  if (hashedEmail && customerProspect) {
    try {
      const decryptedJSON = JSON.parse(
        caesarDecrypt(hashedEmail, customerProspect)
      )
      if (decryptedJSON.pastOrders.length) {
        isCustomerOrProspect = "customer"
      } else {
        isCustomerOrProspect = "prospect"
      }
    } catch (es) {
      // eslint-disable-next-line no-console
      console.log("decrypt error: ", es)
    }
  }
  // this user object should be updated when user log in or out.
  const user = {
    gId: "n/a",
    abTestName: "n/a",
    adBlocker: false,
    authStatus: "anonymous",
    commerceToolsID: "n/a",
    customerProspect: isCustomerOrProspect,
    envName: "development",
    knownStatus: "unknown",
    profileRole: "guest",
    returningStatus: "new visitor",
    emailId: hashedEmail || "n/a",
  }

  // fetch okta tokens for both logged in and anonymous users
  const oktaToken = localStorage.getItem("okta-token-storage")
  const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token")
  if (oktaToken && oktaToken !== "{}") {
    // user is logged in
    const oktaObject = JSON.parse(oktaToken)
    const claim = oktaObject?.accessToken?.claims || {}
    // user.uId = claim.uid || "n/a";
    claim.businessType === "Consumer"
      ? (user.profileRole = "consumer")
      : (user.profileRole = "professional")
    user.commerceToolsID = claim.commercetoolsID || "n/a"
    if (!isFromRegisterUser) {
      user.returningStatus = "returning customer"
    }
    user.authStatus = "logged in"
    user.knownStatus = "known"
  } else if (anonymousOktaToken) {
    // anonymous user
    let oktaObject
    try {
      oktaObject = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {}
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Anonymous Okta Token can not be decoded......")
    }
    if (oktaObject) {
      user.gId = oktaObject.gId || "n/a"
    }
  }
  return user
}

export const getEventInfo = step => {
  return JSON.stringify({
    eventAction: "checkout:" + step + ":edit",
    eventName: "checkout:" + step + ":edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:" + step,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}

export const getAddPromoEventInfo = async (promoCodeLable = "expand") => {
  if (window.adobeDataLayer) {
    const eventInfo = {
      eventName: "checkout:payment & billing:promo code:expand",
      eventAction: "checkout:payment & billing:promo code:expand",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: promoCodeLable,
      internalLinkPosition: "checkout",
      internalLinkZoneName: "checkout:payment and billing",
      internalLinkType: "checkout:promo code",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
    })
  }
}

export const updatePromoAnalytics = async (
  status,
  cartObj,
  promo,
  action,
  productDiscounts
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    eventAction: "checkout:payment & billing:promo code:" + action,
    eventName: "checkout:payment & billing:promo code:" + action,
    eventType: "navigation",
    eventMsg:
      status === "success"
        ? action === "remove"
          ? "promocode removed successfully"
          : "promocode applied successfully"
        : status?.toLowerCase(),
    eventStatus: status === "success" ? "success" : "failure",
    internalLinkName: action,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:promo code",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    promoCode: promo,
  }

  if (cartObj) {
    const { cart } = await calculateCartData(
      {
        cart: cartObj,
        i18n: {
          productDiscounts: productDiscounts || "Product Discounts",
        },
      },
      true
    )
    page.cart = cart
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const getCheckoutReviewEventInfo = (
  type,
  link,
  needJson,
  purchasePathAnalytics = ""
) => {
  const eventInfo = {
    eventAction: "checkout:review:" + type,
    eventName: "checkout:review:" + type,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:review",
    internalLinkURL: link
      ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
      : "n/a",
    clickInternalLinks: "true",
    productSource: purchasePathAnalytics,
  }
  if (needJson) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const addPlaceOrderDataLayer = (link, purchasePathAnalytics) => {
  const eventInfo = getCheckoutReviewEventInfo(
    "place order",
    link,
    true,
    purchasePathAnalytics
  )
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const getCheckoutSignEventInfo = type => {
  const eventInfo = {
    eventAction: "checkout:shipping:sign in",
    eventName: "checkout:shipping:sign in",
    eventType: "navigation",
    eventMsg: type === "success" ? "n/a" : "please enter a valid password",
    eventStatus: type === "success" ? "success" : "failure",
    internalLinkName: "sign in",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  return eventInfo
}
export const addCheckoutSignDataLayer = type => {
  const eventInfo = getCheckoutSignEventInfo(type)
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const addAnalyticsAddressEdit = contactNumber => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const productInfo = page?.cart?.item?.map(i => i?.productInfo)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "checkout:shipping:edit",
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventName: "checkout:shipping:edit",
    eventType: "navigation",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:shipping:edit",
    internalLinkURL: "n/a",
    internalLinkZoneName: "checkout:shipping:navigation",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const getOTPAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:customer information:get otp",
    eventName: "checkout:customer information:get otp",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "get otp",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:customer information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const changeNumberAnalytics = (edit = false) => {
  const eventInfo = {
    eventAction: `checkout:${
      edit ? "customer information" : "mobile number verification modal"
    }:${edit ? "mobile number edit" : "edit number"}`,
    eventName: `checkout:${
      edit ? "customer information" : "mobile number verification modal"
    }:${edit ? "mobile number edit" : "edit number"}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: edit ? "edit" : "edit number",
    internalLinkPosition: "checkout",
    internalLinkType: edit ? "checkout:mobile number" : "checkout:modal",
    internalLinkZoneName: edit
      ? "checkout:customer information"
      : "checkout:mobile number verification modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const changeNumberSignInAnalytics = (edit = false) => {
  const eventInfo = {
    eventAction: `checkout:customer information:mobile number edit`,
    eventName: `checkout:customer information:mobile number edit`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "edit number",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:mobile number",
    internalLinkZoneName: "checkout:customer information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const verifyOTPAnalytics = (success = false) => {
  const eventInfo = {
    eventAction: "checkout:mobile number verification modal:verify",
    eventName: "checkout:mobile number verification modal:verify",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: success ? "success" : "failure",
    internalLinkName: "verify",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:modal",
    internalLinkZoneName: "checkout:mobile number verification modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const resendOTPAnalytics = () => {
  const eventInfo = {
    eventAction: `checkout:mobile number verification modal:resend otp`,
    eventName: `checkout:mobile number verification modal:resend otp`,
    eventType: "navigation",
    eventMsg: "n/a",
    internalLinkName: "resend otp",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:modal",
    internalLinkZoneName: "checkout:mobile number verification modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const thankYouAnalytics = () => {
  const eventInfo = {
    eventAction: `checkout:mobile number verification modal:thank you modal:close`,
    eventName: `checkout:mobile number verification modal:thank you modal:close`,
    eventType: "navigation",
    eventMsg: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:modal",
    internalLinkZoneName:
      "checkout:mobile number verification modal:thank you modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const descriptionClickAnalytics = (text = "", link) => {
  const linkText = text.toLowerCase()
  const linkUrl =
    (link.indexOf("http") === -1 ? window.location.origin : "") + link
  const eventInfo = {
    eventAction: `checkout:mobile number verification modal:${linkText}`,
    eventName: `checkout:mobile number verification modal:${linkText}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: linkText,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:modal",
    internalLinkZoneName: "checkout:mobile number verification modal",
    internalLinkURL: linkUrl,
    clickInternalLinks: "false",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const closeClickAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:mobile number verification modal:close",
    eventName: "checkout:mobile number verification modal:close",
    eventType: "navigation",
    eventMsg: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:modal",
    internalLinkZoneName: "checkout:mobile number verification modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const continueToshippingAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:customer information:continue to shipping",
    eventName: "checkout:customer information:continue to shipping",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "continue to shipping",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:customer information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const editCartAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:shipping:edit",
    eventName: "checkout:shipping:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const editDeliveryAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:delivery options:edit",
    eventName: "checkout:delivery options:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:delivery options",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const continueToPaymentAnalytics = () => {
  const eventInfo = {
    eventAction: "checkout:delivery options:next",
    eventName: "checkout:delivery options:next",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: "continue to payment",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:delivery option:standard",
    internalLinkZoneName: "checkout:delivery options",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const saveAddressClickAnalytics = status => {
  const eventInfo = {
    eventAction: `checkout:shipping:edit shipping address modal:${status}`,
    eventName: `checkout:shipping:edit shipping address modal:${status}`,
    eventType: "navigation",
    eventMsg: "n/a",
    internalLinkName: status,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping:edit shipping address modal",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const deliveryOverlayEventInfoAnalytics = (
  pdpUrl = "",
  data = {},
  productInfo = {}
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "checkout:product navigation",
    eventMsg: "n/a",
    eventName: "checkout:product navigation",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(data.name),
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkURL: getAnalyticsUrl(pdpUrl),
    internalLinkZoneName: "checkout:preview",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo,
  })
}
const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = []) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  if (productInfo.length > 0) page["productInfo"] = productInfo
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}
export { addShippingAnalytics }
